import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RevenueHeroModel } from 'src/app/integrations/revenuehero/revenue-hero-model';
import { MeetingBookedEvent } from 'src/app/integrations/revenuehero/types';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { DeviceDetector } from 'src/app/services/segment/device-detector';
import { SegmentService } from 'src/app/services/segment/segment.service';
import { AuthState } from 'src/app/store/auth/auth.state';
import { PopLoading, PushLoading } from 'src/app/store/loading/loading.actions';
import { environment } from 'src/environments/environment';
import { AuthUser } from 'src/models';

@UntilDestroy()
@Component({
  selector: 'app-book-call-widget',
  templateUrl: './book-call-widget.component.html',
  styleUrls: ['./book-call-widget.component.scss'],
})
export class BookCallWidgetComponent implements OnInit {
  @Select(AuthState.user) user$: Observable<AuthUser>;
  @Input() label = 'common.bookCall.label';

  public user: AuthUser;
  private revenueHeroInit: RevenueHeroModel;

  constructor(
    public deviceDetector: DeviceDetector,
    private readonly segment: SegmentService,
    private readonly growthbook: GrowthBookService,
    private readonly store: Store,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) { }

  ngOnInit(): void {
    this.user$.pipe(untilDestroyed(this)).subscribe(user => {
      this.user = user;
    });
  }

  onBookCallClick(): void {
    this.segment.trackInAppEvents('Book Call Widget Clicked', {
      widgetType: 'book-call',
      action: 'button-click',
    });

    this.contactSales();
  }

  contactSales(): void {
    this.store.dispatch(new PushLoading());

    this.revenueHeroInit = new RevenueHeroModel({
      user: this.user,
      routerId: environment.trialWidgetRevenueHeroRouterId,
      scheduleId: environment.trialWidgetRevenueHeroScheduleId,
    });

    this.revenueHeroInit.initialize();
    this.store.dispatch(new PopLoading());

    this.revenueHeroInit.onMeetingBooked = (e: MeetingBookedEvent) => {
      this.trackContactSales(e);
    };
  }

  private trackContactSales(e: MeetingBookedEvent) {
    const {
      booker_email: bookerEmail,
      booking_participants: bookingParticipants,
      booker_name: bookerName,
      reschedule_count: rescheduleCount,
      status: meetingStatus,
    } = e.data.meeting.attributes;

    this.segment.trackInAppEvents('Book a Call Confirmation Pop up', {
      bookingParticipants,
      bookerEmail,
      bookerName,
      rescheduleCount,
      meetingStatus,
    });
  }
}
